import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#logout_svg__a)">
      <path
        fill="#263E6A"
        d="M5.808 21q-.69 0-1.153-.462a1.57 1.57 0 0 1-.463-1.153V5.615q0-.69.463-1.152A1.57 1.57 0 0 1 5.808 4h6.423v1H5.808a.59.59 0 0 0-.423.192.59.59 0 0 0-.193.423v13.77q0 .23.193.423.192.192.423.192h6.423v1zm10.461-4.962-.702-.719L17.887 13H9.23v-1h8.656l-2.32-2.32.702-.718 3.539 3.538z"
      />
    </g>
    <defs>
      <clipPath id="logout_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogout;
